export const joinDefined = (separator: string, parts: unknown[]) =>
  parts
    .filter(element => element !== undefined && element !== null)
    .join(separator);
